import OperatorService from "@/api/services/operator.service";

const OrgService = {
  getList(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/orgs`, { headers: params });
  },

  getListSelect() {
    return OperatorService.get(`/orgs_list`);
  },
  get(id_org) {
    return OperatorService.get(`/orgs/${id_org}`);
  },

  update(id_org, newOrg) {
    return OperatorService.put(`/orgs/${id_org}`, newOrg);
  },

  create(org) {
    return OperatorService.post(`/orgs`, org);
  },

  delete(id_org) {
    return OperatorService.delete(`/orgs/${id_org}`);
  },
};

export default OrgService;
